import React from 'react';
import { useRecoilValue } from 'recoil';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';

export default function History() {
  const { network } = useRecoilValue(AccessInfoSelector);

  switch (network) {
    case 'meetme':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1559091827329#ic_history" /></svg>
      );

    case 'lovoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1511210228811#ic_lv_transaction_history" /></svg>
      );

    case 'vidoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1511210228811#ic_vidoo_list" /></svg>
      );

    default:
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1511210228811#ic_history" /></svg>
      );
  }
}
